/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class UserService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Used to get user data.
   *
   * @returns any User data.
   * @throws ApiError
   */
  public getUser(): CancelablePromise<{
    id: string
    email: string | null
    /**
     * Null indicates that user has no phone number set.
     */
    phoneNumber: string | null
    registeredOAuth2Providers: Array<string>
    userMetadata: Array<{
      provider: string
      email: string
    }>
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/user',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to edit user passord (which user can use to login).
   *
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public putUserPassword(requestBody: { password: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/v2/user/password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to verify existing user with phone number using Firebase.
   * Returns new tokens on success.
   *
   * @param requestBody Request payload needs to have an `idToken` required to
   * identify user to check that user has verified his phone number
   * using Firebase Phone Auth.
   *
   * Check https://firebase.google.com/docs/auth/web/phone-auth for more
   * details.
   *
   * @returns any Phone number verification has been successfully completed.
   * @throws ApiError
   */
  public postPhoneVerify(requestBody: { idToken: string; phoneNumber: string }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/phone/verify',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to connect Google account to user using credential obtained from Google Sign-In.
   * @param requestBody
   * @returns any Account connected successfully.
   * @throws ApiError
   */
  public postUserGoogleSignInConnect(requestBody: {
    /**
     * Credential obtained by client using Sign-in with Google. https://developers.google.com/identity/gsi/web/guides/overview
     */
    credential: string
    projectId: string
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/google-signin/connect/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to connect OAuth2 account to user account.
   * @param requestBody
   * @param projectId
   * @param providerId
   * @returns any Success
   * @throws ApiError
   */
  public postUserOAuth2Connect(
    requestBody: {
      /**
       * Code obtained after OAuth2 flow.
       */
      code: string
      /**
       * A random string generated for OAuth2 flow that was later hashed and send in the request as `code_challenge`.
       */
      codeVerifier: string
    },
    projectId?: string,
    providerId?: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/oauth/connect/{projectId}/{providerId}',
      path: {
        projectId: projectId,
        providerId: providerId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Returns login methods for existing users. If user with given phone number
   * does not exist - returns empty list.
   *
   * @param requestBody
   * @returns any Login methods for user with given phone number.
   * @throws ApiError
   */
  public postLoginMethods(requestBody: { phoneNumber: string }): CancelablePromise<{
    /**
     * Login methods used by user.
     */
    loginMethods: Array<
      'emailOtp' | 'emailPassword' | 'phoneSMS' | 'phonePassword' | 'socialGoogle' | 'socialOpera'
    >
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/login-methods',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to disconnect OAuth2 account from user account.
   * @param projectId
   * @param providerId
   * @returns any Success
   * @throws ApiError
   */
  public postUserOAuth2Disconnect(projectId?: string, providerId?: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/user/oauth/disconnect/{projectId}/{providerId}',
      path: {
        projectId: projectId,
        providerId: providerId
      },
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`,
        404: `When feature is disabled for given environment.`
      }
    })
  }
}
